import { useQuery } from '@tanstack/react-query';
import {
  GetCurrentUserRolesResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export function useUserPermissions() {
  const api = useApi();

  return useQuery<
    GetCurrentUserRolesResponseDto,
    ExtendedAxiosError,
    GetCurrentUserRolesResponseDto
  >({
    queryKey: ['users', 'roles'],
    queryFn: () => api.usersApi.getCurrentRoles().then((r) => r.data),
  });
}
